var React = require('react');

function DownloadIconGrey (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.6113 19.5796V25.6007C28.6113 26.3992 28.2941 27.1649 27.7295 27.7295C27.1649 28.2941 26.3991 28.6113 25.6007 28.6113H4.52668C3.72823 28.6113 2.96248 28.2941 2.39789 27.7295C1.8333 27.1649 1.51611 26.3992 1.51611 25.6007V19.5796","stroke":"#C9C9CC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.5376 12.0527L15.064 19.5792L22.5905 12.0527","stroke":"#C9C9CC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15.0635 19.579V1.51562","stroke":"#C9C9CC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

DownloadIconGrey.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = DownloadIconGrey;

DownloadIconGrey.default = DownloadIconGrey;
